import { DateTime } from 'luxon'

/**
 *  日付のフォーマット
 * @param {string} dateString 'yyyy/MM/dd'
 * @returns 'M/d(ccccc)'
 */
export const formatDate = (dateString) =>
  // 曜日の表示
  DateTime.fromFormat(dateString.replace(/-/g, '/'), 'yyyy/MM/dd').toFormat('M/d(ccccc)', {
    locale: 'ja',
  })

/**
 *  時間のフォーマット
 * @param {string} timeString 'H:mm:ss'
 * @returns 'H:mm'
 */
export const formatTime = (timeString) =>
  DateTime.fromFormat(timeString, 'H:mm:ss').toFormat('H:mm')

/**
 * 無効値を'?'で置き換えてjoinする
 * @param {Array<any>} values 値の配列
 * @returns {string} 値の配列の文字列表記
 */
const joinWithQuestion = (values) =>
  values.map((value) => (value || '?')).join(' ')

/**
 * ETC利用記録を短く表記するフォーマッタ
 * @param {object} log 走行記録
 * @returns {string} ETC利用記録の文字列
 */
export const formatEtc = log =>
  log.etcUsage || log.etcPrice || log.etcTimes
    ? joinWithQuestion([
      log.etcUsage,
      log.etcPrice,
      'x',
      log.etcTimes,
      '回 =',
      log.etcPrice && log.etcTimes
        ? Number(log.etcPrice * log.etcTimes).toLocaleString()
        : '?',
      '円',
    ])
    : '利用なし'
